import { ILocalFerkelDto } from "../../../db/database";
import { BluetoothDataFormat } from "../../../store/bluetooth/bluetooth-data-format";
import { IProzessDto } from "../../../api/backend-api-v7";
import {
  ProzessEventOperationTypes,
  ProzessInputData,
} from "../../../store/prozess-events/prozess-events.actions";

export interface ConnectedState {
  transponder: BluetoothDataFormat | undefined;
  givenData: ProzessInputData | undefined;
  prevRecordId: string;
  isManuallyEmpty: boolean;
  shouldIgnoreBluetoothData: boolean;
  shouldCreateProzessEventForMultipleProzess: boolean;
  editedValue: string | undefined;
  isEditing: boolean;
  ferkel: ILocalFerkelDto[];
}

export interface ConnectedDispatch {
  onChanged: (prozessInputData: ProzessInputData) => void;
  givenDataApplied: (workflowId: number) => void;
}

export interface OwnProps {
  prozess: IProzessDto;
  recordId: string;
  manualInput: boolean;
  shouldValidate: boolean;
  setIsValidationError: (isError: boolean) => void;
  saveRecord: () => void;
}

export interface Props extends OwnProps, ConnectedState, ConnectedDispatch {}

export interface TransponderState {
  transponder: string;
  metaData: BluetoothDataFormat | null;
  isError: boolean;
  isValid: boolean;
  isProzessEdited?: boolean;
}

export interface TransponderAction {
  type: TransponderActionType;
  payload: {
    value: string | string[] | undefined;
    metaData?: BluetoothDataFormat | null;
    isRequired?: boolean;
    shouldKeepValue?: boolean;
    status: ProzessEventOperationTypes;
    isValid?: boolean;
    isProzessEdited?: boolean;
  };
}

export enum TransponderActionType {
  INIT,
  PROZESS_DATA_CHANGED,
  RESET,
  PROZESS_DATA_EDITED,
}
